import { Route as ConfigRoute, PageTitle } from 'config';

const titleMap = {
  [ConfigRoute.UPCOMING_MENUS]: PageTitle.UPCOMING_MENUS,
  [ConfigRoute.CARTS]: PageTitle.CARTS,
  [ConfigRoute.ORDER_HISTORY]: PageTitle.ORDER_HISTORY,
  [ConfigRoute.GIVEAWAYS]: PageTitle.GIVEAWAYS,
  [ConfigRoute.PROFILE]: PageTitle.PROFILE,
  [ConfigRoute.MY_FAVORITES]: PageTitle.MY_FAVORITES,
  [ConfigRoute.TRACKING]: PageTitle.TRACKING,
  [ConfigRoute.REFER]: PageTitle.REFER,
};

const firstPathRegExp = /\/[^/?]*/;

export function setPageHead(pathname: string): void {
  const result = firstPathRegExp.exec(pathname);
  if (result && titleMap[result[0]]) {
    document.title = titleMap[result[0]];
  } else {
    document.title = PageTitle.DEFAULT;
  }
  window.scrollTo(0, 0);
}

export function setScrollerWidth(): void {
  // Different browsers on different operating systems will have a scrollbar of different size.
  // This method works only if scrollbar is present on a page.
  const scrollerWidth = window.innerWidth - document.body.scrollWidth;
  if (scrollerWidth > 0) {
    document.documentElement.style.setProperty('--scroller-width', `${scrollerWidth}px`);
  }
}
